import { render } from "./PopularGames.vue?vue&type=template&id=e7b107e6"
import script from "./PopularGames.vue?vue&type=script&lang=js"
export * from "./PopularGames.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__